/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Gl_6_TInputs */

const en_mk_tut_gl_6_t = /** @type {(inputs: Mk_Tut_Gl_6_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill`)
};

const id_mk_tut_gl_6_t = /** @type {(inputs: Mk_Tut_Gl_6_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill`)
};

/**
* | output |
* | --- |
* | "Skill" |
*
* @param {Mk_Tut_Gl_6_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_gl_6_t = /** @type {((inputs?: Mk_Tut_Gl_6_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Gl_6_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_gl_6_t(inputs)
	return en_mk_tut_gl_6_t(inputs)
});